import React, { useState } from "react";
import { fetchUploadRepository } from "../../../redux/slices/RepositorysSlice";
import { useAppDispatch } from "../../../redux/store/store";
import { INewRepository } from "../../../types/Repositorys";
import { useNavigate } from "react-router-dom";
import { refreshToken } from "../../../refreshToken";
import '../../core//NewRepositoryPage/NewRepositoryPage.css';
import Swal from "sweetalert2";
import {
  isHttpCodeSuccess,
  handleSwalMessage,
} from "../../../Helpers/Http.commons";

const NewRepositoryPage = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [formValid, setFormValid] = useState(false);
  const [uploadRepository, setUploadRepository] = useState<INewRepository>({
    repositoryName: "",
    repositoryDescription: "",
    organization: "",
    businessName: "",
    businessCostCenter: "",
    businessResponsible: "",
    requestUser: "",
    ownerUser: "",
    metadataKeys: []
  });

  const [metadataKeys, setMetadataList] = useState([""]);

  const checkFormValid = (): boolean => {
    const {
      repositoryName,
      repositoryDescription,
      organization,
      businessName,
      businessCostCenter,
      businessResponsible,
      requestUser,
      ownerUser,
      metadataKeys
    } = uploadRepository;

    return Boolean(
      repositoryName &&
      repositoryDescription &&
      organization &&
      businessName &&
      businessCostCenter &&
      businessResponsible &&
      requestUser &&
      ownerUser &&
      metadataKeys
    );
  };

  const handleSelectChange = (e: any) => {
    const { value } = e.target;
    setUploadRepository({ ...uploadRepository, organization: value });
    const validForm = checkFormValid();
    setFormValid(validForm);
  };

  function validateField(value: string, regex: RegExp) {
    return regex.test(value);
  }

  const handleSubmit = (e: any) => {
    refreshToken();
    e.preventDefault();

    let hasError = false; // variable que indica si hay algún campo con error de regex

    // Validación de cada campo con regex
    const isNameValid = validateField(
      uploadRepository.repositoryName,
      /^[a-zA-Z0-9-]+$/u
    );
    if (!isNameValid) {
      hasError = true;
    }

    const isDescriptionValid = validateField(
      uploadRepository.repositoryDescription,
      /^[a-zA-Z0-9ÑñÁáÉéÍíÓóÚú\s-]+$/u
    );
    if (!isDescriptionValid) {
      hasError = true;
    }

    const isBusinessNameValid = validateField(
      uploadRepository.businessName,
      /^[a-zA-Z0-9ÑñÁáÉéÍíÓóÚú\s-]+$/u
    );
    if (!isBusinessNameValid) {
      hasError = true;
    }

    const isBusinessCostCenterValid = validateField(
      uploadRepository.businessCostCenter,
      /^[a-zA-Z0-9-]+$/u
    );
    if (!isBusinessCostCenterValid) {
      hasError = true;
    }

    const isBusinessResponsibleValid = validateField(
      uploadRepository.businessResponsible,
      /^[a-zA-Z0-9ÑñÁáÉéÍíÓóÚú\s-]+$/u
    );
    if (!isBusinessResponsibleValid) {
      hasError = true;
    }

    const isRequestUserValid = validateField(
      uploadRepository.requestUser,
      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/u
    );
    if (!isRequestUserValid) {
      hasError = true;
    }

    const isOwnerUserValid = validateField(
      uploadRepository.ownerUser,
      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/u
    );
    if (!isOwnerUserValid) {
      hasError = true;
    }

    if (uploadRepository.metadataKeys.length > 10) {
      hasError = true;
    }

    if (hasError) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "Uno o más campos tienen un formato incorrecto",
      });
      e.preventDefault();
    } else {
      if (checkFormValid()) {
        const formData = new FormData();
        formData.append("json", JSON.stringify(uploadRepository));
        console.log(JSON.stringify(uploadRepository));
        dispatch(fetchUploadRepository(uploadRepository)).then(
          (responseData) => {
            if (fetchUploadRepository.fulfilled.match(responseData)) {
              const { statusCode, response, error } = responseData.payload;
              const swalData: any = handleSwalMessage(responseData.payload, status);
              Swal.fire(swalData);

              if (isHttpCodeSuccess(statusCode)) {
                console.log('============ REDIRECT LOG: [NewRepositoryPage] - Navigate to /');
                navigate("/");
              }
            } else if (fetchUploadRepository.rejected.match(responseData)) {
              Swal.fire({
                icon: "error",
                title: "Error de Conexión",
                text: "Revise su conexión a internet y vuelva a intentar",
              });
            }
          }
        );
      }
    }
  };

  const updateListItem = (
    // list: MetadataListItem[],
    list: string[],
    index: number,
    key: string
  ) => {
    // list[index] = { ...list[index], key };
    list[index] = key;
    return list;
  };



  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    index: number
  ) => {
    const list = [...metadataKeys] as string[];
    const isNameValid = validateField(
      e.target.value,
      /^[a-zA-Z0-9-]+$/u
    );
    if (isNameValid) {
      setMetadataList(updateListItem(list, index, e.target.value));
    }
  };

  const handleremove = (e: any, index: any) => {
    const list = [...metadataKeys] as string[];
    list.splice(index, 1);
    setMetadataList(list);
    e.preventDefault();
  };

  const isItemDuplicated = (item: string) => {
    var countItem = 0;
    for (var i = 0; i<=metadataKeys.length; i++) {
      if (metadataKeys[i] === item) {
        countItem = countItem + 1;
      }
    }
    if (countItem>1){
      return true;
    } else{
      return false;
    }

  };

  const handleaddclick = (e: any) => {
    try {
      if (metadataKeys.length <= 10) {

        if (!isItemDuplicated(metadataKeys[metadataKeys.length-1])) {
          setMetadataList([...metadataKeys, ""]);
          setUploadRepository({
            ...uploadRepository,
            metadataKeys: metadataKeys,
          });
        } else{
          Swal.fire({
            icon: "error",
            title: "Metadatos",
            text: "Item ya existe",
          });
          e.preventDefault();
        }
      } else {
        Swal.fire({
          icon: "error",
          title: "Metadatos",
          text: "El maximo de metadatos soportados es 10",
        });
        e.preventDefault();
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div className="upload-container ">
      <div className="pds-card pds-productCard">
        <div className="pds-card-section pds-card-bg-primary-blue-2" tabIndex={0}>
          <h3 className="pds-card-title pds-typography-truncate">
            Nuevo repositorio
          </h3>
          <p className="pds-typography-body-14">
            Una vez creado el repositorio se generara una solicitud de aprobacion
            o rechazo, segun estime el administrador
          </p>
        </div>
        <div className="pds-card-section">
          <form
            noValidate
            data-gtm-form="pdsFormValidation"
            name="pdsFormValidation"
            className="pds-form-wrapper pds-form-enable-validations"
            action="#"
          >
            <div className="pds-form-field">
              <div className="pds-erroredInput">
                <div className="pds-labeledInput">
                  <label
                    htmlFor="pdsFormValidation-labeledInputId"
                    className="pds-label"
                  >
                    Nombre del Repositorio:
                    <span className="pds-label-required" aria-hidden="true">
                      *
                    </span>
                  </label>
                  <input
                    id="pdsFormValidation-labeledInputId"
                    pattern="^[a-zA-Z0-9-]+$"
                    aria-label=""
                    type="text"
                    className="pds-validation"
                    required
                    aria-required="true"
                    onChange={(e) =>
                      setUploadRepository({
                        ...uploadRepository,
                        repositoryName: e.target.value,
                      })
                    }
                    minLength={5}
                    maxLength={35}
                  />
                </div>
                <div className="pds-error">
                  <span
                    className="pds-util-flex-align-center"
                    id="pdsFormValidation-error-example-id"
                    tabIndex={0}
                  >
                    Formato incorrecto descripcion del repositorio debe ser solo
                    caracteres alfanumericos, minimo 5 y maximo 60 caracteres
                  </span>
                </div>
              </div>
            </div>
            <div className="pds-form-field">
              <div className="pds-erroredInput">
                <div className="pds-labeledInput">
                  <label
                    htmlFor="pdsFormValidation-helperInput"
                    className="pds-label"
                  >
                    Descripcion del Repositorio:
                    <span className="pds-label-required" aria-hidden="true">
                      *
                    </span>
                  </label>
                  <input
                    id="pdsFormValidation-helperInput"
                    pattern="^[a-zA-Z0-9ÑñÁáÉéÍíÓóÚú\s-]+$"
                    aria-label=""
                    type="text"
                    className="pds-validation"
                    aria-describedby="helper-text-id"
                    required
                    aria-required="true"
                    onChange={(e) =>
                      setUploadRepository({
                        ...uploadRepository,
                        repositoryDescription: e.target.value,
                      })
                    }
                    minLength={5}
                    maxLength={120}
                  />
                </div>
                <div className="pds-error">
                  <span
                    className="pds-util-flex-align-center"
                    id="pdsFormValidation-error-example-id"
                    tabIndex={0}
                  >
                    Formato incorrecto descripcion del repositorio debe ser solo
                    caracteres alfanumericos, minimo 5 y maximo 120 caracteres
                  </span>
                </div>
              </div>
            </div>
            <div className="pds-form-field">
              <div className="pds-erroredInput">
                <div className="pds-labeledInput">
                  <label
                    htmlFor="pdsFormValidation-helperInput"
                    className="pds-label"
                  >
                    Nombre del Negocio:
                    <span className="pds-label-required" aria-hidden="true">
                      *
                    </span>
                  </label>
                  <input
                    id="pdsFormValidation-helperInput"
                    pattern="^[a-zA-Z0-9ÑñÁáÉéÍíÓóÚú\s-]+$"
                    aria-label=""
                    type="text"
                    className="pds-validation"
                    aria-describedby="helper-text-id"
                    required
                    aria-required="true"
                    onChange={(e) =>
                      setUploadRepository({
                        ...uploadRepository,
                        businessName: e.target.value,
                      })
                    }
                    minLength={5}
                    maxLength={60}
                  />
                </div>
                <div className="pds-error">
                  <span
                    className="pds-util-flex-align-center"
                    id="pdsFormValidation-error-example-id"
                    tabIndex={0}
                  >
                    Formato incorrecto descripcion del repositorio debe ser solo
                    caracteres alfanumericos, minimo 5 y maximo 60 caracteres
                  </span>
                </div>
              </div>
            </div>
            <div className="pds-form-field">
              <div className="pds-erroredSelect">
                <div className="pds-labeledSelect">
                  <label htmlFor="erroredSelectWithLabel" className="pds-label">
                    Compañia:
                    <span className="pds-label-required" aria-hidden="true">
                      *
                    </span>
                  </label>
                  <div className="pds-select">
                    <select
                      id="erroredSelectWithLabel"
                      name="select-input"
                      className="pds-validation"
                      aria-describedby="error-example-id"
                      aria-invalid="true"
                      required
                      aria-required="true"
                      value={uploadRepository.organization}
                      onChange={handleSelectChange}
                    >
                      <option value="" hidden />
                      <option value="Principal">Principal</option>
                      <option value="Cuprum">Cuprum</option>
                    </select>
                  </div>
                </div>
                <div className="pds-error">
                  <span
                    className="pds-util-flex-align-center"
                    id="error-example-id"
                  >
                    Por favor seleccione una compañia.
                  </span>
                </div>
              </div>
            </div>

            <div className="pds-form-field">
              <div className="pds-erroredInput">
                <div className="pds-labeledInput">
                  <label
                    htmlFor="pdsFormValidation-helperInput"
                    className="pds-label"
                  >
                    Centro de costos del negocio:
                    <span className="pds-label-required" aria-hidden="true">
                      *
                    </span>{" "}
                  </label>
                  <input
                    id="pdsFormValidation-helperInput"
                    pattern="^[a-zA-Z0-9-]+$"
                    aria-label=""
                    type="text"
                    className="pds-validation"
                    aria-describedby="helper-text-id"
                    required
                    aria-required="true"
                    onChange={(e) =>
                      setUploadRepository({
                        ...uploadRepository,
                        businessCostCenter: e.target.value,
                      })
                    }
                    minLength={5}
                    maxLength={60}
                  />
                </div>
                <div className="pds-error">
                  <span
                    className="pds-util-flex-align-center"
                    id="pdsFormValidation-error-example-id"
                    tabIndex={0}
                  >
                    Formato incorrecto descripcion del repositorio debe ser solo
                    caracteres alfanumericos, minimo 5 y maximo 60 caracteres
                  </span>
                </div>
              </div>
            </div>
            <div className="pds-form-field">
              <div className="pds-erroredInput">
                <div className="pds-labeledInput">
                  <label
                    htmlFor="pdsFormValidation-helperInput"
                    className="pds-label"
                  >
                    Responsable del Negocio:
                    <span className="pds-label-required" aria-hidden="true">
                      *
                    </span>{" "}
                  </label>
                  <input
                    id="pdsFormValidation-helperInput"
                    pattern="^[a-zA-Z0-9ÑñÁáÉéÍíÓóÚú\s-]+$"
                    aria-label=""
                    type="text"
                    className="pds-validation"
                    aria-describedby="helper-text-id"
                    required
                    aria-required="true"
                    onChange={(e) =>
                      setUploadRepository({
                        ...uploadRepository,
                        businessResponsible: e.target.value,
                      })
                    }
                    minLength={5}
                    maxLength={60}
                  />
                </div>
                <div className="pds-error">
                  <span
                    className="pds-util-flex-align-center"
                    id="pdsFormValidation-error-example-id"
                    tabIndex={0}
                  >
                    Formato incorrecto descripcion del repositorio debe ser solo
                    caracteres alfanumericos, minimo 5 y maximo 60 caracteres
                  </span>
                </div>
              </div>
            </div>
            <div className="pds-form-field">
              <div className="pds-erroredInput">
                <div className="pds-labeledInput">
                  <label
                    htmlFor="pdsFormValidation-labeledInputId"
                    className="pds-label"
                  >
                    Email de usuario solicitante:
                    <span className="pds-label-required" aria-hidden="true">
                      *
                    </span>{" "}
                  </label>
                  <input
                    id="pdsFormValidation-labeledInputId"
                    aria-label=""
                    type="email"
                    className="pds-validation"
                    pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}"
                    required
                    aria-required="true"
                    onChange={(e) =>
                      setUploadRepository({
                        ...uploadRepository,
                        requestUser: e.target.value,
                      })
                    }
                    minLength={5}
                    maxLength={60}
                  />
                </div>
                <div className="pds-error">
                  <span
                    className="pds-util-flex-align-center"
                    id="pdsFormValidation-error-example-id"
                    tabIndex={0}
                  >
                    Formato de email solicitante incorrecto debe volver a ingresar
                    el correo
                  </span>
                </div>
              </div>
            </div>
            <div className="pds-form-field">
              <div className="pds-erroredInput">
                <div className="pds-labeledInput">
                  <label
                    htmlFor="pdsFormValidation-labeledInputId"
                    className="pds-label"
                  >
                    Email de dueño del repositorio:
                    <span className="pds-label-required" aria-hidden="true">
                      *
                    </span>
                  </label>
                  <input
                    id="pdsFormValidation-labeledInputId"
                    aria-label=""
                    type="email"
                    className="pds-validation"
                    pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}"
                    required
                    aria-required="true"
                    onChange={(e) =>
                      setUploadRepository({
                        ...uploadRepository,
                        ownerUser: e.target.value,
                      })
                    }
                    minLength={5}
                    maxLength={60}
                  />
                </div>
                <div className="pds-error">
                  <span
                    className="pds-util-flex-align-center"
                    id="pdsFormValidation-error-example-id"
                    tabIndex={0}
                  >
                    Formato de email solicitante incorrecto debe volver a ingresar
                    el correo
                  </span>
                </div>
              </div>
            </div>
            <div className="pds-form-field">
              Metadata Keys
              {/* <table className="pds-table"> */}
              <table className="metadata-table">
                <tbody>
                  {metadataKeys.map((x, i) => (
                    <tr key={i} >
                      <td>
                        <input
                          type="text"
                          pattern="^[a-zA-Z0-9-]+$"
                          name="key"
                          className="pds-validation"
                          value={x}
                          onChange={(e) => handleInputChange(e, i)}
                          minLength={2}
                          maxLength={16}
                        />
                      </td>
                      <td>
                        {metadataKeys.length !== 1 && metadataKeys.length -1 > i &&(
                          <button
                            className="pds-button pds-button-tertiary"
                            onClick={(e) => handleremove(e, i)}
                          >
                            x
                          </button>
                        )}
                      </td>
                      <td>
                        {metadataKeys.length - 1 === i && (
                          <button
                            className="pds-button pds-button-tertiary"
                            onClick={handleaddclick}
                          >
                            Agregar Metadata
                          </button>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <div className="pds-error">
                <span
                  className="pds-util-flex-align-center"
                  id="pdsFormValidation-error-example-id"
                  tabIndex={0}
                >
                  Formato incorrecto de metadata, solo debe tener
                  caracteres alfanumericos, minimo 2 y maximo 16 caracteres
                </span>
              </div> */}
            </div>
            <div className="pds-form-ctas">
              <button
                className="pds-button pds-button-primary"
                onClick={handleSubmit}
              >
                Enviar
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default NewRepositoryPage;
